
import { mapGetters } from 'vuex'
export default {
	name: 'BargainSettings',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
	},
    computed: {
        ...mapGetters({
            bargainImMessageTop: 'bargaining/bargainImMessageTop',
            userinfo: 'user/userinfo'
        }),
        hasErrors() {
            // 判断是否有任何错误提示
            if (this.form.autoAgreePriceSwitch && !this.form.autoAgreePrice) {
                return true;
            }
            if (this.form.autoAgreePrice && !this.priceReg.test(this.form.autoAgreePrice)) {
                return true;
            }
            if (this.form.autoAgreePrice && Number(this.form.autoAgreePrice) >= Number(this.bargainImMessageTop?.goodsPrice || 0)) {
                return true;
            }
            if (this.form.autoRefusePriceSwitch && this.form.autoRefusePrice && this.form.autoAgreePrice &&
                Number(this.form.autoAgreePrice) <= Number(this.form.autoRefusePrice)) {
                return true;
            }
            if (this.form.autoAgreePrice && !this.isFeeLoading && Number(this.form.autoAgreePrice) < this.serviceCharge) {
                return true;
            }
            if (this.bargainFeeError) {
                return true;
            }
            return false;
        }
    },
	data() {
		return {
			dialogVisible: false,
			form: {
				// 自动同意买家出价开关
				autoAgreePriceSwitch: false,
				// 自动同意买家出价价格
				autoAgreePrice: '',
				// 自动拒绝买家出价开关
				autoRefusePriceSwitch: false,
				// 自动拒绝买家出价价格
				autoRefusePrice: '',
				// 是否支持被砍价
				bargainSwitch: false,
                // 是否支持系统自动首次还价
                autoFirstCounterOfferSwitch: false
			},
			// 新增字段
			serviceCharge: 0,
			income: 0,
			priceReg: new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/),
			isFeeLoading: false, // 加载状态标记
            debounceTimer: null, // 防抖定时器
            bargainFeeError: '', // 存储代售费接口错误信息
            confirmDialogVisible: false, // 确认弹窗可见性
            isManualBargainSwitch: false, // 标记是否为手动操作
            previousBargainSwitchState: false, // 保存之前的状态
            isUserAction: false, // 标记是否为用户主动操作
		}
	},
	watch: {
		visible(val) {
			this.dialogVisible = val
			if (val) {
				this.getData()
			}
		},
        // 监听不想被砍价开关变化
        'form.bargainSwitch'(val) {
            if (val && !this.isManualBargainSwitch) {
                // 如果是自动开启，直接执行逻辑
                // 如果开启了"不想被砍价"，关闭其他两个开关
                this.form.autoAgreePriceSwitch = false
                this.form.autoRefusePriceSwitch = false
                // 清理相关数据
                this.clearAutoAgreeData()
                this.clearAutoRefuseData()
            }
        },
        // 监听自动同意买家出价开关变化
        'form.autoAgreePriceSwitch'(val) {
            if (val) {
                // 如果开启了"自动同意"，关闭"不想被砍价"开关
                this.form.bargainSwitch = false
                // 自动勾选自动首次还价
                this.form.autoFirstCounterOfferSwitch = true
            } else {
                // 如果关闭了"自动同意"，清理相关数据
                this.clearAutoAgreeData()
            }
        },
        // 监听自动拒绝买家出价开关变化
        'form.autoRefusePriceSwitch'(val) {
            if (val) {
                // 如果开启了"自动拒绝"，关闭"不想被砍价"开关
                this.form.bargainSwitch = false
            } else {
                // 如果关闭了"自动拒绝"，清理相关数据
                this.clearAutoRefuseData()
            }
        }
	},
	methods: {
        // 处理自动同意开关变化
        handleAutoAgreeSwitchChange(val) {
            // 只在用户主动操作时触发埋点
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '开启自动同意',
                    userId: this.userinfo?.id,
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    isOpen: val
                }
            })
        },

        // 处理自动拒绝开关变化
        handleAutoRefuseSwitchChange(val) {
            // 只在用户主动操作时触发埋点
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '开启自动拒绝',
                    userId: this.userinfo?.id,
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    isOpen: val
                }
            })
        },

        // 处理自动首次还价点击
        handleAutoFirstCounterOfferClick() {
            // 切换状态
            this.form.autoFirstCounterOfferSwitch = !this.form.autoFirstCounterOfferSwitch
            // 触发埋点
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '勾选自动还价',
                    userId: this.userinfo?.id,
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    isOpen: this.form.autoFirstCounterOfferSwitch
                }
            })
        },

        // 处理复选框自身的变更事件
        handleAutoFirstCounterOfferCheckboxChange(val) {
            // 只触发埋点，不再改变状态，因为 v-model 已经改变了状态
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '勾选自动还价',
                    userId: this.userinfo?.id,
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    isOpen: val
                }
            })
        },

        // 处理"不想被砍价"开关变化
        handleBargainSwitchChange(val) {
            // 触发埋点
            if (val) {
                this.$trackEvent({
                    eventType: 'click',
                    trackParams: {
                        eventName: '开启不接受砍价',
                        userId: this.userinfo?.id,
                        goodsNo: this.bargainImMessageTop?.goodsNo,
                        isOpen: val
                    }
                })
            }

            // 标记为手动操作
            this.isManualBargainSwitch = true;
            // 保存当前状态
            this.previousBargainSwitchState = val;

            if (val) {
                // 如果是开启操作，显示确认弹窗
                this.confirmDialogVisible = true;
                // 先恢复原来的状态，等确认后再修改
                this.form.bargainSwitch = false;
            } else {
                // 如果是关闭操作，直接执行
                this.isManualBargainSwitch = false;
            }
        },

        // 确认开启"不想被砍价"
        confirmBargainSwitch() {
            // 关闭确认弹窗
            this.confirmDialogVisible = false;
            // 设置开关状态为开启
            this.form.bargainSwitch = true;
            // 关闭其他开关
            this.form.autoAgreePriceSwitch = false;
            this.form.autoRefusePriceSwitch = false;
            // 清理相关数据
            this.clearAutoAgreeData();
            this.clearAutoRefuseData();
            // 重置手动操作标记
            this.isManualBargainSwitch = false;
        },

        // 取消开启"不想被砍价"
        cancelBargainSwitch() {
            // 关闭确认弹窗
            this.confirmDialogVisible = false;
            // 保持开关状态为关闭
            this.form.bargainSwitch = false;
            // 重置手动操作标记
            this.isManualBargainSwitch = false;
        },

        // 获取还价配置
        getData() {
            const params = {
                action: {
                    goodsNo: this.bargainImMessageTop.goodsNo,
                    sellerId: this.bargainImMessageTop.sellerId
                }
            }
            this.$api.bargainImSellerGetCounterOfferConfigAPI(params).then(({ success, data, info }) => {
                if (success && (data || {})) {
                    // 初始化表单数据
                    this.form.autoAgreePriceSwitch = !!data.autoAgreePriceSwitch
                    this.form.autoAgreePrice = data.autoAgreePrice || ''
                    this.form.autoRefusePriceSwitch = !!data.autoRefusePriceSwitch
                    this.form.autoRefusePrice = data.autoRefusePrice || ''
                    this.form.bargainSwitch = data.bargainSwitch
                    this.form.autoFirstCounterOfferSwitch = data.autoFirstCounterOfferSwitch

                    // 如果有自动同意价格，则计算初始的代售费和到手价
                    if (this.form.autoAgreePriceSwitch && this.form.autoAgreePrice) {
                        this.calculateBargainFee(this.form.autoAgreePrice)
                    }
                } else {
                    this.$message.error(info || '获取数据失败')
                }
            }).catch(err => {
                console.error(err)
                this.$message.error('获取数据失败')
            })
        },

        // 清理自动同意相关数据
        clearAutoAgreeData() {
            this.form.autoAgreePrice = ''
            this.form.autoFirstCounterOfferSwitch = false
            this.bargainFeeError = '' // 清空错误信息
        },

        // 清理自动拒绝相关数据
        clearAutoRefuseData() {
            this.form.autoRefusePrice = ''
        },

        // 新增方法：计算代售费和到手价
        calculateBargainFee(price) {
            // 设置加载状态
            this.isFeeLoading = true

            const params = {
                action: {
                    goodsPrice: Number(price),
                    gameId: this.bargainImMessageTop?.gameId,
                    goodsCatalogueId: this.bargainImMessageTop?.goodsCategoryId,
                    goodsNo: this.bargainImMessageTop?.goodsNo
                }
            }
            this.$api.getBargainFee(params).then(res => {
                if (!res.success) {
                    // 保存接口返回的错误信息
                    this.bargainFeeError = res.info || '获取代售费失败'
                    return
                }
                this.serviceCharge = res.data.serviceFee
                this.income = parseFloat(Number(price) - Number(res.data.serviceFee)).toFixed(2)
            }).catch(err => {
                // 保存接口请求异常的错误信息
                this.bargainFeeError = '获取代售费失败，请稍后重试'
                console.error(err)
            }).finally(() => {
                // 无论成功失败都关闭加载状态
                this.isFeeLoading = false
            })
        },

        // 自动同意价格输入框变动
        onUpdatePrice(newValue) {
            this.form.autoAgreePrice = this.form.autoAgreePrice.replace(/^(0+)|\D+/g, '')
            // 清空上一次请求的错误信息
            this.bargainFeeError = ''

            if (!this.priceReg.test(newValue)) {
                return
            }

            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }

            // 使用防抖，延迟500毫秒再发起请求
            this.debounceTimer = setTimeout(() => {
                this.calculateBargainFee(newValue)
            }, 500)
        },

        // 自动拒绝价格输入框变动
        onUpdateRefusePrice(newValue) {
            this.form.autoRefusePrice = this.form.autoRefusePrice.replace(/^(0+)|\D+/g, '')
        },

		// 处理关闭弹窗
		handleClose(done) {
            // 直接关闭弹窗，不进行表单验证
            done()
		},
		// 保存砍价设置
		saveBargainSetting() {
            const params = {
                action: {
                    ...this.form,
                    goodsNo: this.bargainImMessageTop.goodsNo,
                    sellerId: this.bargainImMessageTop.sellerId
                }
            }
            this.$api.bargainImSellerSetCounterOfferConfigAPI(params).then(({ success, data, info }) => {
                if (success && (data || {})) {
                    this.$message.success('设置成功')
                } else {
                    this.$message.error(info || '设置失败')
                }
            })
			this.dialogVisible = false
		},
		// 验证表单
        validateForm() {
            // 如果开启了自动同意，则验证对应的价格必须填写且合法
            if (this.form.autoAgreePriceSwitch) {
                if (!this.form.autoAgreePrice) {
                    return false
                }
                if (!this.priceReg.test(this.form.autoAgreePrice)) {
                    return false
                }
                // 验证自动同意价格需低于商品价格
                if (Number(this.form.autoAgreePrice) >= Number(this.bargainImMessageTop?.goodsPrice || 0)) {
                    return false
                }
                if (Number(this.form.autoAgreePrice) < this.serviceCharge) {
                    return false
                }
                // 如果同时开启了自动拒绝，则验证自动同意价格需大于自动拒绝价格
                if (this.form.autoRefusePriceSwitch && this.form.autoRefusePrice &&
                    Number(this.form.autoAgreePrice) <= Number(this.form.autoRefusePrice)) {
                    return false
                }
                // 如果代售费接口有错误，也不能通过验证
                if (this.bargainFeeError) {
                    return false
                }
            }

            // 如果开启了自动拒绝，则验证对应的价格必须填写且合法
            if (this.form.autoRefusePriceSwitch) {
                if (!this.form.autoRefusePrice) {
                    return false
                }
                if (!this.priceReg.test(this.form.autoRefusePrice)) {
                    return false
                }
                // 验证自动拒绝价格需低于商品价格
                if (Number(this.form.autoRefusePrice) >= Number(this.bargainImMessageTop?.goodsPrice || 0)) {
                    return false
                }
                // 如果同时开启了自动同意，则验证自动拒绝价格需低于自动同意价格
                if (this.form.autoAgreePriceSwitch && this.form.autoAgreePrice &&
                    Number(this.form.autoRefusePrice) >= Number(this.form.autoAgreePrice)) {
                    return false
                }
            }

            return true
        },
		// 提交表单
		submitForm() {
            if (this.validateForm()) {
                // 表单验证通过，执行保存操作
                this.saveBargainSetting()
            } else {
                this.$message.error('请完善表单信息')
            }
		},
	}
}
